export default "__VITE_ASSET___app/immutable/assets/modal-logo-light-green.BdqJvACQ.svg__"